import { observer } from 'mobx-react';
import React, { Component } from 'react';

interface IProps {
  color: string;
  label: string;
}

class View extends Component<IProps> {
  render() {
    const { color, label } = this.props;

    return (
      <div>
        <div>{label}</div>

        <div className='is-relative'>
          <div
            className='test-tube-fluid'
            style={{ backgroundColor: color }}
          ></div>
          <div className='test-tube m-1'></div>
        </div>
      </div>
    );
  }
}

const TestTube = observer(View);
export default TestTube;
